(function (angular) {
    'use strict';

    angular.module('broadcast')


        .component('step1', {
            bindings: {
                forms: "="
            },
            controller: ["$rootScope", "$state", "$stateParams", "broadcastWizardService", "WizardHandler", "channelsProvider",
                function ($rootScope, $state, $stateParams, broadcastWizardService, WizardHandler, channelsProvider) {
                    var ctrl = this;

                    ctrl.bws = broadcastWizardService;

                    ctrl.channels = [{
                        name: channelsProvider.sms.name,
                        id: "sms",
                        disabled: false,
                        title: "SMS"
                    }, {
                        name: channelsProvider.fbMessenger.name,
                        id: "fbMessenger",
                        disabled: ctrl.bws.fbPage === undefined,
                        title: ctrl.bws.fbPage === undefined ? "Facebook Messenger is not configured" : "Facebook Messenger"
                    }, {
                        name: channelsProvider.appMessaging.name,
                        id: "appMessaging",
                        disabled: ctrl.bws.teams.length === 0,
                        title: ctrl.bws.teams.length === 0 ? "App Messaging is not configured" : "App Messaging"
                    }, {
                        name: channelsProvider.whatsApp.name,
                        id: "whatsApp",
                        disabled: ctrl.bws.whatsAppConfigurations.length === 0,
                        title: ctrl.bws.whatsAppConfigurations.length === 0 ? "WhatsApp is not configured" : "WhatsApp"
                    }];


                    ctrl.onChannelChange = function () {
                        $rootScope.$broadcast("broadcast:channel:changed", ctrl.bws.step1Model.channel);
                        // reset the messages - TODO: tell the user ... 😂
                        ctrl.bws.step2Model.messageParts = [];
                        if (ctrl.bws.step1Model.channel === "whatsApp") {
                            ctrl.bws.step1Model.requireOptIn = true;
                        } else {
                            ctrl.bws.step1Model.requireOptIn = false;
                        }

                    }


                    ctrl.next = function () {
                        // once we have clicked next, display any validation errors if there are any
                        ctrl.showInvalid = true;

                        if (ctrl.forms.step1Form.$valid) {

                            if ($stateParams.new === true) {
                                broadcastWizardService.createBroadcast()
                                    .then(function () {
                                        $stateParams.new = null;
                                        WizardHandler.wizard("broadcastWizard").next();
                                    });
                            } else {
                                broadcastWizardService.updateBroadcast()
                                    .then(function (succeeded) {
                                        if (succeeded) {
                                            WizardHandler.wizard("broadcastWizard").next();
                                        }
                                    });
                            }
                        }

                    }
                    ctrl.cancel = function () {
                        // If editing a scheduled campaign, go back there

                        var type = "drafts";

                        if (ctrl.bws.step4Model) {
                            type = ctrl.bws.step4Model.schedule ? "scheduled" : "drafts";
                        }
                        var params = { type: type }
                        $state.go('main.apiSpace.existingBroadcasts', params);
                    }

                    // ctrl.$onInit = function () { }

                }],
            templateUrl: 'components/toolkit/broadcast/templates/step1.html'
        })

})(window.angular);